import React from "react";
import {Row, Col} from "antd";
import {
    CalendarOutlined,
    GiftOutlined,
    TrophyOutlined, SmileOutlined,
} from "@ant-design/icons";
import '../../../styles/component/celebrations/celebration.stats.cards.scss';
import {CelebrationsCard, eventDataType} from "../type/celebrations.types";

interface celebrationsStatsProps {
    newBirthdayData: eventDataType;
    newAnniversaryData: eventDataType;
}

const CelebrationStats = (props: celebrationsStatsProps) => {

    const todayCount =
        (props.newBirthdayData?.today?.length || 0) +
        (props.newAnniversaryData?.today?.length || 0);

    const birthdaysThisMonth =
        (props.newBirthdayData?.passed?.length || 0) +
        (props.newBirthdayData?.today?.length || 0) +
        (props.newBirthdayData?.upcoming?.length || 0);


    const anniversariesThisMonth =
        (props.newAnniversaryData?.passed?.length || 0) +
        (props.newAnniversaryData?.today?.length || 0) +
        (props.newAnniversaryData?.upcoming?.length || 0);

    const thisMonthCount = birthdaysThisMonth + anniversariesThisMonth;

    const Stats: CelebrationsCard[] = [
        {
            title: "Today",
            value: todayCount,
            icon: <CalendarOutlined/>,
            className: "today",
        },
        {
            title: "This Month",
            value: thisMonthCount,
            icon: <SmileOutlined/>,
            className: "month",
        },
        {
            title: "Birthdays",
            value: birthdaysThisMonth,
            icon: <GiftOutlined/>,
            className: "birthdays",
        },
        {
            title: "Anniversaries",
            value: anniversariesThisMonth,
            icon: <TrophyOutlined/>,
            className: "anniversaries",
        },
    ];

    return (
        <div className={'cards-div'}>
            <Row gutter={16} className="stats-cards">
                {Stats.map((item) => (
                    <Col key={item.title} xs={24} sm={12} md={12} lg={6}>
                        <div className={`stat-card ${item.className}`}>
                            <div className="icon">{item.icon}</div>
                            <div className="content">
                                <div className="title">{item.title}</div>
                                <div className="value">{item.value}</div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default CelebrationStats;